import { IAppConfig } from '@cemex-core/cmx-rollout-toggle-v1';
import { environment } from 'environments/environment';

export function appConfigFactory(): IAppConfig {
  return {
    name: 'OTCustApp',
    key: environment.roxKey,
    options: {
      version: environment.version,
    },
  };
}
